import {
  BankType,
  DepartmentType,
  EmployeeContactType,
  EmployeeNamePrefixType,
  FinanceChanelType,
  IdentifyPersionType,
  PndType,
  PrompPayType,
} from "@/enums/enums";
import store from "@/store/index";
import { SetDateForInputDate } from "./dateHelper";
import { ValidateEmployeeTemplate } from "./employeeHelper";
import { ReadExcelFile } from "./excelHelper";
import { NewObject } from "./shareHelper";

function GetExcelImportEmployeeJson(data: any) {
  const listImportData: any = [];
  if (data[0].length == 23) {
    data.shift();
    data.forEach((row: any) => {
      const importData: any = {};
      if (row[0]) {
        importData.no = row[0];
        importData.employeeCode = row[1] ? row[1].toString() : "";
        importData.prefixName = row[2] ? row[2].toString() : "";
        importData.firstNameTh = row[3] ? row[3].toString() : "";
        importData.lastNameTh = row[4] ? row[4].toString() : "";
        importData.firstNameEn = row[5] ? row[5].toString() : "";
        importData.lastNameEn = row[6] ? row[6].toString() : "";
        importData.citizenIDCode = row[7] ? row[7].toString() : "";
        importData.departmentCode = row[8] ? row[8].toString() : "";
        importData.positionCode = row[9] ? row[9].toString() : "";
        importData.email = row[10] ? row[10].toString() : "";
        importData.phoneNumber = row[11] ? row[11].toString() : "";
        importData.address = row[12] ? row[12].toString() : "";
        importData.subDistrict = row[13] ? row[13].toString() : "";
        importData.city = row[14] ? row[14].toString() : "";
        importData.province = row[15] ? row[15].toString() : "";
        importData.postalCode = row[16] ? row[16].toString() : "";
        importData.startDate = row[17] ? row[17].toString() : "";
        importData.defaultSalary = row[18] ? row[18].toString() : "";
        importData.registerSSO = row[19] ? row[19].toString() : "";
        importData.defaultWHT = row[20] ? row[20].toString() : "";
        importData.financeChannel = row[21] ? row[21].toString() : "";
        importData.bankAccountNumber = row[22] ? row[22].toString() : "";
        listImportData.push(importData);
      }
    });
  }
  return listImportData;
}

export function DoImportEmployeeExcel(fileImport: File) {
  return ReadExcelFile(fileImport).then((value: any) => {
    return GetExcelImportEmployeeJson(value.contents);
  });
}

function GetPrefixName(prefixName: string): any {
  const prefixObj = {
    name: "นาย",
    value: EmployeeNamePrefixType.Mr,
  };
  if (prefixName) {
    switch (prefixName) {
      case "นาย":
        prefixObj.name = prefixName;
        prefixObj.value = EmployeeNamePrefixType.Mr;
        break;
      case "นาง":
        prefixObj.name = prefixName;
        prefixObj.value = EmployeeNamePrefixType.Mrs;
        break;
      case "นางสาว":
        prefixObj.name = prefixName;
        prefixObj.value = EmployeeNamePrefixType.Ms;
        break;
    }

    return prefixObj;
  } else {
    return prefixObj;
  }
}

function GetRegisterSSO(registerSSO: string) {
  if (registerSSO) {
    if (registerSSO == "มี") {
      return { value: 0 };
    } else if (registerSSO == "ไม่มี") {
      return { value: 1 };
    } else {
      return { value: 0 };
    }
  } else {
    return { value: 0 };
  }
}

function GetDateJsonString(startDate: string | number) {
  if (startDate) {
    const outputDate = SetDateForInputDate(startDate.toString());
    if (outputDate) {
      return outputDate.ToDateJsonString();
    } else {
      return "";
    }
  } else {
    return "";
  }
}

function GetDefaultDepartment() {
  const departmentList: any = store.state.Department.departmentList;
  const defaultDepartment = departmentList.find((d: any) => d.type == DepartmentType.Undefined);
  return defaultDepartment ? defaultDepartment.id : 1;
}
export function GetImportEmployeeTemplate(index: number) {
  const employeeTemplate = {
    id: index,
    code: {
      value: "",
      validateError: false,
    },
    file: {
      fileName: "",
      fileType: "",
      rawString: "",
    },
    prefixName: NewObject(GetPrefixName("")),
    prefixNameOther: {
      value: "",
      validateError: false,
    },
    firstNameTH: {
      value: "",
      validateError: false,
    },
    lastNameTH: {
      value: "",
      validateError: false,
    },
    firstNameEN: {
      value: "",
      validateError: false,
    },
    lastNameEN: {
      value: "",
      validateError: false,
    },
    personalIDCodeType: IdentifyPersionType.CitizenId,
    citizenIDCode: {
      value: "",
      validateError: false,
    },
    department: {
      value: "" as any,
      validateError: false,
    },
    contractType: { value: EmployeeContactType.Monthly },
    position: {
      value: "" as any,
      validateError: false,
    },
    email: {
      value: "",
      validateError: false,
    },
    mobile: {
      value: "",
      validateError: false,
    },
    emergencyContact: {
      value: "",
      validateError: false,
    },
    emergencyMobile: {
      value: "",
      validateError: false,
    },
    address: {
      value: "",
      validateError: false,
    },
    subDistrict: {
      value: "",
      validateError: false,
    },
    city: {
      value: "",
      validateError: false,
    },
    province: {
      value: "",
      validateError: false,
    },
    postalCode: {
      value: "",
      validateError: false,
    },
    startDate: {
      value: GetDateJsonString(Date()),
      //value: employeeJson.startDate,
      validateError: false,
    },
    //employeeCompensation
    defaultSalary: {
      value: "0.00",
      validateError: false,
    },
    salaryAdjustmentAccount: { id: -1 },
    registerSSO: NewObject(GetRegisterSSO("")),
    wht: true,
    whtType: { value: PndType.PND1kor },
    defaultWHT: {
      value: "0.00",
      validateError: false,
    },
    defaultWHT402: {
      value: "0.00",
      validateError: false,
    },
    //employeeFinance
    financeChannelType: { value: FinanceChanelType.Cash },
    bankTypeId: -2,
    bankAccountType: { value: BankType.SavingAccount },
    bankAccountName: {
      value: "",
      validateError: false,
    },
    bankAccountNumber: {
      value: "",
      validateError: false,
    },
    bankAccountBranchName: {
      value: "",
      validateError: false,
    },
    bankAccountBranchNumber: {
      value: "",
      validateError: false,
    },
    promptPayType: { value: PrompPayType.CitizenId },
    promptPayIDNumber: {
      value: "",
      validateError: false,
    },
    //employeeAllowance
    defaultAllowancePersonal: {
      value: "60,000.00",
      validateError: false,
    },
    defaultAllowanceSpouse: {
      value: "0.00",
      validateError: false,
    },
    defaultAllowancePersonCare: {
      value: "0.00",
      validateError: false,
    },
    defaultAllowanceChild: {
      value: "0.00",
      validateError: false,
    },
    defaultAllowanceLifeInsurance: {
      value: "0.00",
      validateError: false,
    },
    defaultAllowanceHealthInsurance: {
      value: "0.00",
      validateError: false,
    },
    defaultAllowanceFundContribution: {
      value: "0.00",
      validateError: false,
    },
    defaultAllowanceSocialSecurityContributions: {
      value: "9000.00",
      validateError: false,
    },
    defaultAllowanceFund: {
      value: "0.00",
      validateError: false,
    },
    defaultAllowanceOther: {
      value: "0.00",
      validateError: false,
    },
  };
  return employeeTemplate;
}
export function ConvertToImportEmployeeTemplateList(employeeJsonList: any) {
  const importEmployeeTemplateList: any = [];
  if (employeeJsonList.length > 0) {
    employeeJsonList.forEach((employeeJson: any, index: number) => {
      const employeeTemplate = GetImportEmployeeTemplate(index + 1);
      employeeTemplate.code.value = employeeJson.employeeCode;
      employeeTemplate.prefixName = NewObject(GetPrefixName(employeeJson.prefixName));
      employeeTemplate.firstNameTH.value = employeeJson.firstNameTh;
      employeeTemplate.lastNameTH.value = employeeJson.lastNameTh;
      employeeTemplate.firstNameEN.value = employeeJson.firstNameEn;
      employeeTemplate.lastNameEN.value = employeeJson.lastNameEn;
      employeeTemplate.citizenIDCode.value = employeeJson.citizenIDCode;
      employeeTemplate.department.value = employeeJson.departmentCode ? { code: employeeJson.departmentCode } : "";
      employeeTemplate.position.value = employeeJson.positionCode ? { code: employeeJson.positionCode } : "";
      employeeTemplate.email.value = employeeJson.email;
      employeeTemplate.mobile.value = employeeJson.phoneNumber;
      employeeTemplate.address.value = employeeJson.address;
      employeeTemplate.subDistrict.value = employeeJson.subDistrict;
      employeeTemplate.city.value = employeeJson.city;
      employeeTemplate.province.value = employeeJson.province;
      employeeTemplate.postalCode.value = employeeJson.postalCode;
      employeeTemplate.startDate.value = GetDateJsonString(employeeJson.startDate);
      employeeTemplate.defaultSalary.value = employeeJson.defaultSalary.FormatMoney();
      employeeTemplate.registerSSO = NewObject(GetRegisterSSO(employeeJson.registerSSO));
      employeeTemplate.defaultWHT.value = employeeJson.defaultWHT.FormatMoney();
      employeeTemplate.bankTypeId = employeeJson.financeChannel;
      employeeTemplate.bankAccountNumber.value = employeeJson.bankAccountNumber;
      importEmployeeTemplateList.push(employeeTemplate);
    });
  }

  return importEmployeeTemplateList;
}

function CheckCodeDuplicates(employeeTemplateList: any) {
  const valueArr = employeeTemplateList.map((item: any) => {
    return item.code.value;
  });
  const findDuplicates = (arr: any) => arr.filter((item: any, index: number) => item && arr.indexOf(item) != index);
  const listCodeDuplicates = findDuplicates(valueArr);

  if (listCodeDuplicates.length > 0) {
    listCodeDuplicates.forEach((code: string) => {
      for (let i = 0; i < employeeTemplateList.length; i++) {
        if (employeeTemplateList[i].code.value == code) {
          employeeTemplateList[i].code.validateError = true;
        }
      }
    });

    return false;
  } else {
    return true;
  }
}

export function ValidateEmployeeTemplateList(employeeTemplateList: any) {
  let isValidated = true;
  const arrayErrorList: Array<number> = [];
  if (employeeTemplateList && employeeTemplateList.length > 0) {
    if (!CheckCodeDuplicates(employeeTemplateList)) {
      isValidated = false;
    }

    employeeTemplateList.forEach((employeeTemplate: any, index: number) => {
      if (!ValidateEmployeeTemplate(employeeTemplate, true)) {
        isValidated = false;
        arrayErrorList.push(index + 1);
      }
    });
  } else {
    isValidated = false;
  }
  return { isValidated: isValidated, arrayErrorList: arrayErrorList };
}
function GetExcelImportPayRunJson(row: any) {
  const listImportData: any = [];
  const columnLength = row[0].length;
  const header: any = [];
  if (columnLength > 2) {
    header.push("");
    header.push("");
    for (let columnNo = 2; columnNo < columnLength; columnNo++) {
      let headerName = row[0][columnNo];
      if (headerName) {
        const splitHeader = headerName.split("(");
        headerName = splitHeader[splitHeader.length - 1];
        if (headerName) {
          headerName = headerName.split(")")[0];
        }
      }
      header.push(headerName);
    }
  }
  row.shift();
  row.forEach((column: any) => {
    const importData: any = {};
    if (column[0]) {
      importData.employeeCode = column[0] ? column[0].toString() : "";
      importData.revenueDeductList = [];
      if (columnLength > 2) {
        for (let columnNo = 2; columnNo < columnLength; columnNo++) {
          importData.revenueDeductList.push({
            code: header[columnNo],
            total: (column[columnNo] ? column[columnNo].toString() : "0").ToNumber(),
          });
        }
      }
      listImportData.push(importData);
    }
  });
  return listImportData;
}
export function DoImportPayRunExcel(fileImport: File) {
  return ReadExcelFile(fileImport).then((value: any) => {
    return GetExcelImportPayRunJson(value.contents);
  });
}

export const ValidateBeforeImportSalary = (employeeSalaryList: any) => {
  const employeeIdList = employeeSalaryList.map((item: any) => {
    return item.employeeCode;
  });
  const hasDuplicates = (arr: any[]): boolean => new Set(arr).size !== arr.length;
  if (hasDuplicates(employeeIdList)) {
    return false;
  } else {
    return true;
  }
};
